export type TBakersRecommendation = {
  guid: string
  title: string
  description: string
  accepted: boolean
  accepted_at: string
  comment: string
  created_at?: string
}

export type TUpdateRecommendation = {
  title?: string
  comment?: string
  accepted: boolean
}

export type TBakersRecommendationRow = TBakersRecommendation & {
  id: string // guid
}

export enum RECOMMENDATION_INSIGHT {
  recommendation = 'recommendation',
  insight = 'insight',
}
